export default __webpack_public_path__ + "static/business-21a0e0be56f927b78ca29218b4c3da72.png";